var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var ThemeBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var commonStore = store.commonStore;
    var propsConnect = {
        clientCode: commonStore.clientCode
    };
    return __assign({}, propsConnect);
};
